export const T = {
  en_GB: {
    noProductsCost:
      "No products added yet. Use the Custom Portfolio Builder to add products, then cost data will be available.",
    completeRiskAssessment: "Please complete the risk assessment to see cost data.",
    enterInvestmentAmount: "Please enter an investment amount to see cost data.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see cost data.`,
    notAvailable:
      "Cost data is not available for this portfolio. This may be because the cost calculation API is not running. Please contact your advisor.",
    snapshotMissingMessage: "Cost data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading cost data. Please refresh the page.",
    unavailable: "Cost Data Unavailable",
  },
  nb_NO: {
    noProductsCost:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter, deretter vil kostnadsdata være tilgjengelig.",
    completeRiskAssessment: "Fullfør risikovurderingen for å se kostnadsdata.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se kostnadsdata.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se kostnadsdata.`,
    notAvailable:
      "Kostnadsdata er ikke tilgjengelig for denne porteføljen. Dette kan skyldes at kostnadsberegnings-API-et ikke kjører. Kontakt din rådgiver.",
    snapshotMissingMessage: "Kostnadsdata må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av kostnadsdata. Oppdater siden.",
    unavailable: "Kostnadsdata ikke tilgjengelig",
  },
} as const;
